module.exports = __webpack_public_path__ + "/eb57055cd4f1eb9bf8110dc4bb1f95f9.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/docusign-switch/assets/logos/samsung_logo_@2x.png
 ** module id = 1549
 ** module chunks = 0
 **/